import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { IReducer } from '../../../../redux/configureStore';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: calc(100vh - 4rem);
  padding: 2rem;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: ${(props) => props.theme.border.default};
  box-shadow: ${(props) => props.theme.shadow.default};
  padding: 3rem 4rem;
  max-width: 40rem;
  text-align: center;
`;

const Title = styled.h1`
  color: ${(props) => props.theme.colors.mainColor};
  font-size: ${(props) => props.theme.fontSize.max};
  margin: 0 0 ${(props) => props.theme.margin.default} 0;
`;

const Subtitle = styled.h2`
  color: ${(props) => props.theme.colors.lightGray};
  font-size: ${(props) => props.theme.fontSize.big};
  font-weight: 400;
  margin: 0 0 ${(props) => props.theme.margin.max} 0;
`;

const Message = styled.p`
  color: ${(props) => props.theme.colors.gray};
  font-size: ${(props) => props.theme.fontSize.medium};
  line-height: 1.5;
  margin: 0;
`;

function WelcomeApp() {
  const profile = useSelector((reducer: IReducer) => reducer.userProfile);
  const nome = profile.nomeRazaoSocial || 'usuário';

  return (
    <Container>
      <Card>
        <Title>Bem-vindo(a), {nome}</Title>
        <Subtitle>Módulo Legado SPB</Subtitle>
        <Message>Selecione uma opção no menu lateral para começar.</Message>
      </Card>
    </Container>
  );
}

export default WelcomeApp;
